<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '90%',
        color: '#fff',
    }">
        <div class="deositPOP_container">
             <CustomHeader text="" :isPopupCloseBackIcon="true" @closePopup="close" />
            <div class="iframe-wrapper">
                <iframe :src="iframeUrl" frameborder="0"></iframe>
            </div>
        </div>
    </van-popup>

</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n';
import CustomHeader from '../../components/common/customHeader.vue';

const { t } = useI18n();
const show = ref(false)
const iframeUrl = ref('')
const open = (url : any) => {
    show.value = true
    iframeUrl.value = url
}
const close = () => {
    show.value = false
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.deositPOP_container {
    /* background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    min-height: 100vh;
    padding: 70px 0;
    overflow-y: auto; */
}
.van-popup {
   background-image: url('@/assets/main_bg.png');
   background-size: cover;
   background-repeat: repeat;
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
    width: 100%;
    min-height: 100vh;
    padding: 70px 0;
}
.deositPOP_container::-webkit-scrollbar {
    display: none;
}

.iframe-wrapper {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 9999;
    background: #ffffff;
}

.iframe-wrapper iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.scrollable-content {
    /* flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; */
}

.van-popup::-webkit-scrollbar {
    display: none;
}
</style>